import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ff78362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_list, {
      padding: "",
      class: "q-px-sm"
    }, {
      default: _withCtx(() => [
        (!_ctx.mobile && (_ctx.isBusinessAdmin || _ctx.isTechnicalAdmin))
          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: 0,
              clickable: "",
              to: { name: _ctx.ROUTE_DATA.PLATFORM_SETTINGS_PAGE.name },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('ADMINISTRATION')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true),
        (!_ctx.mobile)
          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: 1,
              clickable: "",
              to: { name: _ctx.ROUTE_DATA.ACCOUNT_PAGE.name },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('ACCOUNT')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }, 8, ["to"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          "data-user-pilot": "help-center",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('HELP_CENTER')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })), [
          [_directive_close_popup]
        ]),
        (!_ctx.mobile && (_ctx.isClientAdmin || _ctx.isTenantAdmin))
          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: 2,
              onClick: _ctx.goToUserManagementPage,
              clickable: "",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('USER_MANAGEMENT')), 1)
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_q_separator),
    _createVNode(_component_q_list, {
      padding: "",
      class: "q-px-sm"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
          clickable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, _mergeProps({
                  name: _ctx.ICONS_NAME.SIGN_OUT_OUTLINE,
                  color: "grey-dark"
                }, _ctx.ICON_PROPS.MENU), null, 16, ["name"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_SMALL_BODY)), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('SIGN_OUT')), 1)
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })), [
          [_directive_close_popup]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_separator),
    _createVNode(_component_q_item, { class: "bg-grey-lighter" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { class: "text-grey-dark" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, { caption: "" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('BRAND.INPART')) + " ", 1),
                (_ctx.isBeta)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.t('APP_IN_BETA')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_label, { caption: "" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('APP_VERSION', { version: _ctx.appVersion })), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}